const styles = {
  global: {
    '.chakra-toast__inner': {
      color: '#fff',
      fontSize: '16px !important'
    },
    '.chakra-toast__inner .icon svg': {
      width: '24px !important',
      height: '24px !important'
    },
    '.grecaptcha-badge': {
      bottom: '50vh !important',
    },
  }
}

export default styles
